<template>
  <div class="content">
    <!-- start of title -->
    <div class="title-box">
      <el-button type="default" size="mini" @click="$router.go(-1)">返回</el-button>
      <span>平台服务人员准入规则</span>
    </div>
    <!-- end of title -->

    <!-- start of form -->
    <div class="back-color-fff form-box">
      <span class="form-title">服务人员规则</span>
      <el-form :model="formData" :rules="formRules" ref="formData" label-width="200px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="国家公职人员" prop="publicOfficials">
              <el-radio-group v-model="formData.publicOfficials">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>          
          </el-col>
          <el-col :span="12">
            <el-form-item label="犯罪违法记录" prop="criminalRecord">
              <el-radio-group v-model="formData.criminalRecord">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>          
          </el-col>
        </el-row>
        
        <el-row>
          <el-col :span="12">
            <el-form-item label="有正式劳动关系" prop="laborRelations">
              <el-radio-group v-model="formData.laborRelations">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="公司董监高人员" prop="dongJiangao">
              <el-radio-group v-model="formData.dongJiangao">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item label="任务执行人与收款人不一致" prop="taskExecutor">
              <el-radio-group v-model="formData.taskExecutor">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="无医药代表备案" prop="noMedical">
              <el-radio-group v-model="formData.noMedical">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item class="over-label" label="任务执行人与手机未绑定（允许家庭号）" prop="unbound">
              <el-radio-group v-model="formData.unbound">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="姓名与身份证不一致" prop="nameAtypism">
              <el-radio-group v-model="formData.nameAtypism">
                <el-radio label='Y'>可</el-radio>
                <el-radio label='N'>不可</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item prop="ageLowerLimit">
          <template slot="label">
            年龄要求
            <el-tooltip class="item" effect="light">
              <div slot="content">
                <div>年龄要求说明：</div>
                <p>1、举例：限制18岁至55岁；</p>
                <p>2、那么在导入花名册/人员备案/发布任务包时，系统会判断某个人如果再过60天就到55岁的人了则年龄超标，系统会进行拦截，不允许继续操作；</p>
                <div>3、年龄超标定义：根据当前年月日 - 某人员身份证上的出生年月日 - 60天，得出的岁数大于55岁，则超标。</div>
              </div>
              <i class="el-icon-question"></i>
            </el-tooltip>
          </template>
          <div class="age-are-box">
            <el-select
              size="mini"
              v-model="formData.ageLowerLimit"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="item in ageList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
            <span>至</span>
            <el-select
              size="mini"
              v-model="formData.ageUpperLimit"
              placeholder="请选择"
              filterable
              clearable
            >
              <el-option
                v-for="item in ageList"
                :key="item"
                :label="item"
                :value="item"
              >
              </el-option>
            </el-select>
          </div>
        </el-form-item>

        <el-form-item label="月度收入建议上限(元)" prop="revenueRecommendations">
          <el-input type="text" :maxlength="12" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" placeholder="请输入" size="small" v-model="formData.revenueRecommendations"></el-input>
        </el-form-item>
        
        <el-form-item label="月度收入拦截上限(元)" prop="revenueInterception">
          <el-input type="text" :maxlength="12" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" placeholder="请输入" size="small" v-model="formData.revenueInterception"></el-input>
        </el-form-item>

        <el-form-item label="多地收入合并拦截上限(元)" prop="multipleIncome">
          <el-input type="text" :maxlength="12" oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')" placeholder="请输入" size="small" v-model="formData.multipleIncome"></el-input>
        </el-form-item>

      </el-form>
      
      <div class="bottom-btn-box">
        <el-button type="defalut" size="small" >取消</el-button>
        <el-button type="primary" size="small" @click="submitForm()">保存</el-button>
      </div>
    </div>
    <!-- end of form -->
  </div>
</template>

<script>
let labelJson = {
  publicOfficials: '国家公职人员',
  criminalRecord: '犯罪违法记录',
  laborRelations: '有正式劳动关系',
  dongJiangao: '公司董监高人员',
  taskExecutor: '任务执行人与收款人不一致',
  noMedical: '无医药代表备案',
  unbound: '任务执行人与手机未绑定',
  nameAtypism: '姓名与身份证不一致',
  ageLowerLimit: '年龄要求下限',
  ageUpperLimit: '年龄要求上限',
  revenueRecommendations: '月度收入建议上限',
  revenueInterception: '月度收入拦截上限',
  multipleIncome: '多地收入合并拦截上限'
}
export default {
  data() {
    return {
      guid: '',
      // 表单字段
      formData: {
        publicOfficials: 'N',
        criminalRecord: 'N',
        laborRelations: 'N',
        dongJiangao: 'N',
        taskExecutor: 'N',
        noMedical: 'N',
        unbound: 'N',
        nameAtypism: 'N',
        ageLowerLimit: '',
        ageUpperLimit: '',
        revenueRecommendations: 70000,
        revenueInterception: 98000,
        multipleIncome: 98000
      },
      // 表单验证规则
      formRules: {
        publicOfficials: [
          { required: true, message: '国家公职人员必填', trigger: 'change' }
        ],
        criminalRecord: [
          { required: true, message: '犯罪违法记录必填', trigger: 'change' }
        ],
        laborRelations: [
          { required: true, message: '有正式劳动关系必填', trigger: 'change' }
        ],
        dongJiangao: [
          {  required: true, message: '公司董监高人员必填', trigger: 'change' }
        ],
        taskExecutor: [
          { required: true, message: '任务执行人与收款人不一致必填', trigger: 'change' }
        ],
        noMedical: [
          { required: true, message: '无医药代表备案必填', trigger: 'change' }
        ],
        unbound: [
          { required: true, message: '任务执行人与手机未绑定必填', trigger: 'change' }
        ],
        nameAtypism: [
          { required: true, message: '姓名与身份证不一致必填', trigger: 'change' }
        ],
        ageLowerLimit: [
          { required: true, message: '年龄要求必填', trigger: 'blur' }
        ],
        ageUpperLimit: [
          { required: true, message: '年龄要求下限必填', trigger: 'blur' }
        ],
        revenueRecommendations: [
          { required: true, message: '月度收入建议上限(元) 必填', trigger: 'blur' }
        ],
        revenueInterception: [
          { required: true, message: '月度收入拦截上限(元) 必填', trigger: 'blur' }
        ],
        multipleIncome: [
          { required: true, message: '多地收入合并拦截上限(元) 必填', trigger: 'blur' },
          // { type: 'number', max: 100000, message: '不能超过上限10万元', trigger: 'change' }
        ]
      },
      // 保存列表数据，修改时获取每条数据的guid
      list: [],
      ageList: [], // 可选年龄下拉选数据
    };
  },
  created() {
    var arr = [];
    for(var i = 18; i < 71; i++) {
      arr.push(i)
    }
    this.ageList = arr;

    this.getData();
  },
  watch: {},
  methods: {
    /**
     * 获取表单数据
     */
    getData() {
      let that = this;
      that.api.get(
        `/${serverConfig.msConfigureService}/dict/data/get-by-dictType?dictType=平台服务人员准入规则`,
      ).then((resp) => {
        const { data } = resp        
        // 字典分类【平台服务人员准入规则】不存在，则需要新增
        if(!data.data) {
          that.api.postJson(
            `/${serverConfig.msConfigureService}/dict/save-class`,
            {
              "guid": '',
              "dictTypeName": "平台服务人员准入规则",
              "orderNum": 0
            }
          ).then((res) => {
            console.log(res);
            that.guid = res.data.data
          });
        }
        if(data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          let datas = data.data || [];
          console.log(datas)
          // 给表单赋值
          let formData = that.formData;
          datas.forEach(item => {
            // 例如：国家公职人员字段含义，publicOfficials_N
            let key = item.value.split('_')[0];
            let val = item.value.split('_')[1];
            for(var k in formData) {
              if(k == key) {
                formData[k] = val;
              }
            }
          });
          console.log(formData)
          this.formData = formData;
          
          // 由于表单是json数据，无法获取每条数据的guid
          this.list = datas;
          this.guid = datas[0].parentGuid;

        }
      });
    },
    /**
     * 提交表单
     */
    submitForm() {
      let { formData, list } = this;
      this.$refs['formData'].validate((valid) => {
        if (valid) {
          const formArr = [];
          var num = 0;
          for(var k in formData) {
            for(var j in labelJson) {
              if(k == j) {
                formArr.push({
                  "dicName": labelJson[j],
                  "dicValue": j + '_' + formData[k],
                  "orderNum": num++,
                  "parentGuid": this.guid
                })
              }
            }
            // 修改时，赋值guid
            list.forEach(item => {
              formArr.forEach(element => {
                if(element.dicName == item.text) {
                  element.guid = item.guid;
                }
              })
            })
          }
          this.api.postJson(
            `/${serverConfig.msConfigureService}/dict/save-batch`,
            formArr
          ).then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.getData();// 重新刷一遍页面
              this.$message.success('保存成功');
            } else {
              this.$message.error(res.data.msg);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  },
};
</script> 
<style lang="less" scoped>
.content {
  padding: 0px;
  margin: 0px;
  .title-box {
    border-top: 1px solid #E5E5E5;
    background-color: #ffffff;
    padding: 8px 0px;
    position: relative;
    button {
      font-size: 12px;
      color: #212121;
      letter-spacing: 0;
      width: 60px;
      height: 26px;
      padding: 0px;
      border: 1px solid rgba(217,217,217,1);
      border-radius: 2px;
      position: absolute;
      left: 16px;
      top: 6px;
    }
    span {
      text-align: center;
      font-size: 16px;
      font-weight: 400;
    }
  }
  .form-box {
    margin-top: 4px;
    text-align: left;
    .form-title {
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      margin-left: 16px;
    }
    .el-form {
      width: 80%;
      margin: 0 auto;
    }
    .el-form-item {
      margin-bottom: 12px;
    }
    .over-label /deep/ .el-form-item__label {      
      line-height: 21px;
    }
    .el-input {
      width: 314px;
    }
    .age-are-box {
      display: flex;
      align-items: center;
      .el-select {
        width: 142px;
      }
      span {
        margin: 0px 8px;
      }
    }
    .bottom-btn-box {
      padding: 18px 0px ;
      text-align: center;
      border-top: 1px solid #E5E5E5;
      .el-button--primary {
        color: #ffffff;
      }
    }
  }
}
</style>